import { useState, useEffect } from "react";
import { ChevronDown, Loader2 } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FAQSection = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFAQs();
  }, []);

  const fetchFAQs = async () => {
    try {
      const response = await axios.get(`${API}/faqs?active_only=true`);
      setFaqs(response.data);
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-20 bg-[#0a0a0f]">
        <div className="flex items-center justify-center">
          <Loader2 className="w-8 h-8 text-[#00d4aa] animate-spin" />
        </div>
      </section>
    );
  }

  if (faqs.length === 0) {
    return null;
  }

  return (
    <section className="py-20 bg-[#0a0a0f]" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-[#00d4aa] font-mono text-sm mb-4 block">
            {'// SIKÇA SORULAN SORULAR'}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#f0f0f5] mb-4">
            Merak Edilenler
          </h2>
          <p className="text-[#9ca3af] max-w-2xl mx-auto">
            Projeler hakkında en çok sorulan sorular ve cevapları
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={faq.id}
              value={faq.id}
              className="bg-[#16161f] border border-[#2a2a3a] rounded-xl overflow-hidden data-[state=open]:border-[#00d4aa]"
              data-testid={`faq-item-${index}`}
            >
              <AccordionTrigger className="px-6 py-4 text-left hover:no-underline group">
                <span className="text-[#f0f0f5] font-medium group-hover:text-[#00d4aa] transition-colors">
                  {faq.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-4">
                <p className="text-[#9ca3af] leading-relaxed">
                  {faq.answer}
                </p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
